<template>
  <div
    v-if="hasErrors"
    style="padding: 10px; background-color: #FEE9EE; border-radius: 4px;">
    <div class="font-medium text-red-600">入力値にエラーがあります</div>
    <ul
      class="mt-3 list-disc list-inside text-sm text-red-600">
      <li
        v-for="(error, key) in errors"
        :key="key">
        {{ error }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

const errors = computed(() => usePage().props.value.errors)
const hasErrors = computed(() => Object.keys(errors.value).length > 0)
</script>
